import React from 'react';

import '../styles/loader.css';

function Loader (props) {

    return (
        <div className='loader'>This is the loader</div>
    );

};

export default Loader